import React, {useState} from 'react'
import { MiFooter } from '../../components/footer/MiFooter'
import { ContentBodyGraficas} from '../../components/Graficas/ContentBodyGraficas'
import '../UserFeedback/UserFeedback.css'
import './Graficas.css'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import HeaderHome from '../../components/headerHome/HeaderHome'

export const Graficas = () => {
    const [MenuLateralAux, setMenuLateralAux] = useState();


    const chageMenuLateralAux = () => {
        setMenuLateralAux(!MenuLateralAux)
    }
    return (
        <>
            <div className='UserFeedback'  >
                <div className='headerUserFeedback'>
                    <HeaderHome
                        chageMenuLateralAux={chageMenuLateralAux}

                    />
                </div>
                <div className="bodyUserFeedback">
                    <ContentBodyGraficas
                        MenuLateralAux={MenuLateralAux}
                        chageMenuLateralAux={chageMenuLateralAux}
                    />
                </div>
                <div className='footerReservarServicio'>
                    <MiFooter />
                </div>
            </div>
        </>
    )
}
